import {ValidatorFn, Validators} from "@angular/forms";

export function emailValidator(): ValidatorFn {
  return Validators.pattern(
    /^([^@\s]+)@((?:[^@\s]+\.)+[^@\s]{2,})$/i
  );
}
